import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_FETCH_DROPOUTS_DATA_BEGIN,
  MANAGE_SUBS_FETCH_DROPOUTS_DATA_SUCCESS,
  MANAGE_SUBS_FETCH_DROPOUTS_DATA_FAILURE,
  MANAGE_SUBS_FETCH_DROPOUTS_DATA_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';
export function fetchDropoutsData(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_FETCH_DROPOUTS_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      let conditions = args;
      if(args.sortedBy === undefined || args.sortedBy === null) {
        conditions = {
          ...conditions,
          sort: "ascend",
          sortedBy: "cutoff",
        }
      }
      if(conditions.nationalIds && conditions.nationalIds.length === 0) {
        delete conditions.nationalIds
      }
      if(conditions.itemCategory && conditions.itemCategory.length === 0) {
        delete conditions.itemCategory
      }
      // let path = '/viewDropOuts';
      // if(conditions.optimizationEnable){       //call optimization api
      //   path = '/viewDropoutsOptimizeV2';
      // }
      // delete conditions.optimizationEnable;   //COT-8330
      const doRequest = axios.post(`${API_REQUEST_URL}/viewDropoutsOptimizeV2`, conditions, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          const data = res.data;
          if(data && data.data && data.data.length > 0) {
            const len = data.data.length
            for(let i = 0; i < len; i++) {
              data.data[i].uid = 'dropout' + i
            }
          }
          dispatch({
            type: MANAGE_SUBS_FETCH_DROPOUTS_DATA_SUCCESS,
            data: data,
          });
          resolve(data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_FETCH_DROPOUTS_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchDropoutsDataError() {
  return {
    type: MANAGE_SUBS_FETCH_DROPOUTS_DATA_DISMISS_ERROR,
  };
}

export function useFetchDropoutsData() {
  const dispatch = useDispatch();

  const { dropoutsData, fetchDropoutsDataPending, fetchDropoutsDataError } = useSelector(
    state => ({
      dropoutsData: state.manageSubs.dropoutsData,
      fetchDropoutsDataPending: state.manageSubs.fetchDropoutsDataPending,
      fetchDropoutsDataError: state.manageSubs.fetchDropoutsDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchDropoutsData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchDropoutsDataError());
  }, [dispatch]);

  
  return {
    dropoutsData,
    fetchDropoutsData: boundAction,
    fetchDropoutsDataPending,
    fetchDropoutsDataError,
    dismissFetchDropoutsDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_FETCH_DROPOUTS_DATA_BEGIN:
      // Just after a request is sent
   
      return {
        ...state,
        fetchDropoutsDataPending: true,
        fetchDropoutsDataError: null,
      };

    case MANAGE_SUBS_FETCH_DROPOUTS_DATA_SUCCESS:
      // The request is success
    
      return {
        ...state,
        dropoutsData: action.data,
        fetchDropoutsDataPending: false,
        fetchDropoutsDataError: null,
      };

    case MANAGE_SUBS_FETCH_DROPOUTS_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchDropoutsDataPending: false,
        fetchDropoutsDataError: action.data.error,
      };

    case MANAGE_SUBS_FETCH_DROPOUTS_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchDropoutsDataError: null,
      };

    default:
      return state;
  }
}
